(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vison-shipping-calculator"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('vison-shipping-estimator')) return;

    class VisonShippingEstimator extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.form = this.querySelector('.vison-shipping__form');
        this.input = this.querySelector('.vison-shipping__input');
        this.button = this.querySelector('.vison-shipping__button');
        this.result = this.querySelector('.vison-shipping__result');
        this.currency = this.dataset.currency || 'BRL';
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.form.addEventListener('submit', this.handleSubmit);
        this.input.addEventListener('input', this.handleInput);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.handleSubmit);
        this.input?.removeEventListener('input', this.handleInput);
      }

      handleInput() {
        const digits = this.input.value.replace(/\D/g, '').slice(0, 8);
        this.input.value = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
      }

      getThemeRoot() {
        return window.Shopify?.routes?.root || '/';
      }

      getProductScope() {
        return this.closest('.shopify-section') || document;
      }

      getVariantId() {
        const scope = this.getProductScope();
        const input = scope.querySelector('form[action*="/cart/add"] [name="id"]');
        const value = input?.value || this.dataset.variantId;
        return Number.parseInt(value, 10);
      }

      getQuantity() {
        const scope = this.getProductScope();
        const input = scope.querySelector('form[action*="/cart/add"] [name="quantity"]');
        const value = Number.parseInt(input?.value || '1', 10);
        return Number.isFinite(value) && value > 0 ? value : 1;
      }

      async fetchJson(path, options = {}) {
        const response = await fetch(`${this.getThemeRoot()}${path}`, {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            ...(options.body ? { 'Content-Type': 'application/json' } : {}),
            ...(options.headers || {})
          },
          ...options
        });

        const text = await response.text();
        let data = null;

        if (text) {
          try {
            data = JSON.parse(text);
          } catch {
            data = null;
          }
        }

        if (!response.ok) {
          const message = data?.description || data?.message || 'Não foi possível calcular o frete.';
          throw new Error(message);
        }

        return data;
      }

      async lookupPostalCode(cep) {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 2500);

        try {
          const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`, {
            signal: controller.signal,
            headers: { Accept: 'application/json' }
          });

          if (!response.ok) return {};

          const data = await response.json();
          if (data.erro) return {};

          return {
            city: data.localidade || '',
            province: data.uf || ''
          };
        } catch {
          return {};
        } finally {
          window.clearTimeout(timeout);
        }
      }

      buildAddressParams(cep, address) {
        const params = new URLSearchParams();
        params.set('shipping_address[zip]', cep);
        params.set('shipping_address[country]', 'Brazil');

        if (address.city) params.set('shipping_address[city]', address.city);
        if (address.province) params.set('shipping_address[province]', address.province);

        return params.toString();
      }

      async prepareRates(query) {
        await this.fetchJson(`cart/prepare_shipping_rates.json?${query}`, {
          method: 'POST'
        });

        for (let attempt = 0; attempt < 14; attempt += 1) {
          await new Promise((resolve) => window.setTimeout(resolve, 650));
          const data = await this.fetchJson(`cart/async_shipping_rates.json?${query}`);

          if (data?.shipping_rates) return data.shipping_rates;
        }

        throw new Error('O cálculo demorou mais que o esperado. Tente novamente.');
      }

      async clearCart() {
        await this.fetchJson('cart/clear.js', {
          method: 'POST',
          body: JSON.stringify({})
        });
      }

      async addItems(items) {
        if (!items.length) return;

        await this.fetchJson('cart/add.js', {
          method: 'POST',
          body: JSON.stringify({ items })
        });
      }

      buildRestoreItems(cart) {
        return cart.items.map((item) => {
          const restored = {
            id: item.variant_id,
            quantity: item.quantity
          };

          if (item.properties && Object.keys(item.properties).length) {
            restored.properties = item.properties;
          }

          const sellingPlanId = item.selling_plan_allocation?.selling_plan?.id;
          if (sellingPlanId) restored.selling_plan = sellingPlanId;

          return restored;
        });
      }

      getCacheKey(variantId, quantity, cep) {
        return `vison_shipping_${variantId}_${quantity}_${cep}`;
      }

      getCachedRates(key) {
        try {
          const cached = JSON.parse(sessionStorage.getItem(key));
          if (!cached || Date.now() - cached.createdAt > 600000) return null;
          return cached.rates;
        } catch {
          return null;
        }
      }

      setCachedRates(key, rates) {
        try {
          sessionStorage.setItem(key, JSON.stringify({ rates, createdAt: Date.now() }));
        } catch {
          return;
        }
      }

      async estimateRates(variantId, quantity, cep) {
        const cacheKey = this.getCacheKey(variantId, quantity, cep);
        const cachedRates = this.getCachedRates(cacheKey);
        if (cachedRates) return cachedRates;

        const address = await this.lookupPostalCode(cep);
        const originalCart = await this.fetchJson('cart.js');
        const restoreItems = this.buildRestoreItems(originalCart);
        let rates = [];
        let restoreError = null;

        try {
          await this.clearCart();
          await this.addItems([{ id: variantId, quantity }]);
          const query = this.buildAddressParams(cep, address);
          rates = await this.prepareRates(query);
        } finally {
          try {
            await this.clearCart();
            await this.addItems(restoreItems);
          } catch (error) {
            restoreError = error;
          }
        }

        if (restoreError) {
          throw new Error('O carrinho não pôde ser restaurado automaticamente. Recarregue a página antes de continuar.');
        }

        this.setCachedRates(cacheKey, rates);
        return rates;
      }

      formatPrice(value) {
        const amount = Number.parseFloat(value || '0');
        if (amount === 0) return 'Grátis';

        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: this.currency
        }).format(amount);
      }

      getDeliveryTime(rate) {
        const days = Array.isArray(rate.delivery_days) ? rate.delivery_days : [];

        if (days.length >= 2 && days[0] !== days[1]) {
          return `Prazo estimado: ${days[0]} a ${days[1]} dias úteis`;
        }

        if (days.length >= 1) {
          return `Prazo estimado: ${days[0]} ${days[0] === 1 ? 'dia útil' : 'dias úteis'}`;
        }

        return '';
      }

      showMessage(message, isError = false) {
        const paragraph = document.createElement('p');
        paragraph.className = `vison-shipping__message${isError ? ' vison-shipping__message--error' : ''}`;
        paragraph.textContent = message;
        this.result.replaceChildren(paragraph);
      }

      renderRates(rates, cep) {
        if (!rates.length) {
          this.showMessage('Não encontramos opções de entrega para este CEP.', true);
          return;
        }

        const sortedRates = [...rates].sort((a, b) => Number(a.price) - Number(b.price));
        const destination = document.createElement('p');
        destination.className = 'vison-shipping__destination';
        destination.textContent = `Opções de entrega para ${cep.slice(0, 5)}-${cep.slice(5)}:`;

        const list = document.createElement('ul');
        list.className = 'vison-shipping__rates';

        sortedRates.forEach((rate) => {
          const item = document.createElement('li');
          item.className = 'vison-shipping__rate';

          const info = document.createElement('span');
          info.className = 'vison-shipping__rate-info';

          const name = document.createElement('span');
          name.className = 'vison-shipping__rate-name';
          name.textContent = rate.presentment_name || rate.name || 'Entrega';
          info.appendChild(name);

          const deliveryTime = this.getDeliveryTime(rate);
          if (deliveryTime) {
            const time = document.createElement('span');
            time.className = 'vison-shipping__rate-time';
            time.textContent = deliveryTime;
            info.appendChild(time);
          }

          const price = document.createElement('span');
          price.className = 'vison-shipping__rate-price';
          price.textContent = this.formatPrice(rate.price);

          item.append(info, price);
          list.appendChild(item);
        });

        this.result.replaceChildren(destination, list);
      }

      async handleSubmit(event) {
        event.preventDefault();

        const cep = this.input.value.replace(/\D/g, '');
        const variantId = this.getVariantId();
        const quantity = this.getQuantity();

        if (cep.length !== 8) {
          this.showMessage('Digite um CEP válido com 8 números.', true);
          this.input.focus();
          return;
        }

        if (!Number.isFinite(variantId)) {
          this.showMessage('Selecione uma opção do produto antes de calcular.', true);
          return;
        }

        this.button.disabled = true;
        this.button.textContent = 'CALCULANDO...';
        this.showMessage('Consultando as opções de entrega...');

        try {
          const rates = await this.estimateRates(variantId, quantity, cep);
          this.renderRates(rates, cep);
        } catch (error) {
          this.showMessage(error.message || 'Não foi possível calcular o frete.', true);
        } finally {
          this.button.disabled = false;
          this.button.textContent = 'CALCULAR';
        }
      }
    }

    customElements.define('vison-shipping-estimator', VisonShippingEstimator);
  })();
  } catch(e) { console.error(e); }
})();

})();
